var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAoiMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5366 3.63379L15.8171 6.5972M16.8723 9.88989L15.4879 14.8289M12.8537 16.8045H7.91469M4.95127 14.8289L3.30493 9.88989M4.29274 6.92647L8.57322 3.96306",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7561 2.7561C11.7561 2.29035 11.5711 1.84368 11.2417 1.51435C10.9124 1.18502 10.4657 1 9.99999 1C9.53425 1 9.08758 1.18502 8.75825 1.51435C8.42891 1.84368 8.2439 2.29035 8.2439 2.7561C8.2439 3.22184 8.42891 3.66851 8.75825 3.99785C9.08758 4.32718 9.53425 4.5122 9.99999 4.5122C10.4657 4.5122 10.9124 4.32718 11.2417 3.99785C11.5711 3.66851 11.7561 3.22184 11.7561 2.7561Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.366 16.5852C16.366 16.1195 16.1809 15.6728 15.8516 15.3435C15.5223 15.0141 15.0756 14.8291 14.6099 14.8291C14.1441 14.8291 13.6974 15.0141 13.3681 15.3435C13.0388 15.6728 12.8538 16.1195 12.8538 16.5852C12.8538 17.0509 13.0388 17.4976 13.3681 17.8269C13.6974 18.1563 14.1441 18.3413 14.6099 18.3413C15.0756 18.3413 15.5223 18.1563 15.8516 17.8269C16.1809 17.4976 16.366 17.0509 16.366 16.5852Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5122 8.02465C4.5122 7.55891 4.32718 7.11224 3.99785 6.7829C3.66851 6.45357 3.22184 6.26855 2.7561 6.26855C2.29035 6.26855 1.84368 6.45357 1.51435 6.7829C1.18502 7.11224 1 7.55891 1 8.02465C1 8.4904 1.18502 8.93707 1.51435 9.2664C1.84368 9.59573 2.29035 9.78075 2.7561 9.78075C3.22184 9.78075 3.66851 9.59573 3.99785 9.2664C4.32718 8.93707 4.5122 8.4904 4.5122 8.02465Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80492 16.5852C7.80492 16.1195 7.6199 15.6728 7.29057 15.3435C6.96124 15.0141 6.51457 14.8291 6.04882 14.8291C5.58308 14.8291 5.13641 15.0141 4.80707 15.3435C4.47774 15.6728 4.29272 16.1195 4.29272 16.5852C4.29272 17.0509 4.47774 17.4976 4.80707 17.8269C5.13641 18.1563 5.58308 18.3413 6.04882 18.3413C6.51457 18.3413 6.96124 18.1563 7.29057 17.8269C7.6199 17.4976 7.80492 17.0509 7.80492 16.5852Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.02465C19 7.55891 18.815 7.11224 18.4856 6.7829C18.1563 6.45357 17.7096 6.26855 17.2439 6.26855C16.7781 6.26855 16.3315 6.45357 16.0021 6.7829C15.6728 7.11224 15.4878 7.55891 15.4878 8.02465C15.4878 8.4904 15.6728 8.93707 16.0021 9.2664C16.3315 9.59573 16.7781 9.78075 17.2439 9.78075C17.7096 9.78075 18.1563 9.59573 18.4856 9.2664C18.815 8.93707 19 8.4904 19 8.02465Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7V13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10H13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAoiMenuIcon);
export default __webpack_public_path__ + "static/media/aoi-menu-icon.9f705272d969e81f0c133554b9814e13.svg";
export { ForwardRef as ReactComponent };